<template>
  <div :style="wrapStyle">
    <template>
          <div :class="getCss('login-box')">
            <div :class="getCss('login')" :style="styles.fontStyle" v-if="isLogin">
              <div :class="getCss('userinfo-text-up')">
                你好，
                <template>
                  <span :class="getCss('userinfo-text')" v-if="!isRoleReady && isWX " v-html="userName"></span>
                  <span :class="getCss('userinfo-text')" v-if="!isRoleReady && !isWX" v-text="userName"></span>
                  <span :class="getCss('userinfo-text')">{{ partitionName }}</span>
                  <span :class="getCss('userinfo-text')">{{ roleName }}</span>
                </template>
              </div>
              <div  :class="getCss('line-box')" :style="loginLineStyle"></div>
              <div :class="getCss('userinfo-text-down')">
                <template v-if="showRole">
                  <a
                    v-if="isRoleReady"
                    :class="getCss('userinfo-text-button')"
                    @click="showRoleList"
                  >{{ userBindText }}
                  </a>
                  <a
                    v-else
                    :class="getCss('userinfo-text-button')"
                    @click="doBindRole"
                  >{{ userBindText }}
                  </a>
                </template>
                <a
                  v-if="!configurationData.disableRewardRecord"
                  :class="getCss('userinfo-text-button')"
                  @click="handleClaimRecord"
                >领奖记录</a>
                <a
                  v-if="!configurationData.disableRechargeRecord"
                  :class="getCss('userinfo-text-button')"
                  @click="handleRechargeRecord"
                >充值记录</a>
                <!--<br v-if="configurationData.showBindQQ &&
             configurationData.showBindPhone && configurationData.showAccessMakeAppShortCut">-->
                <a
                  v-if="configurationData.showBindQQ"
                  :class="getCss('userinfo-text-button')"
                  @click="showBindQQFunc"
                >{{bindBtnText}}</a>
                <a
                  v-if="configurationData.showBindPhone"
                  :class="getCss('userinfo-text-button')"
                  @click="showBindPhoneFunc"
                >绑定手机</a>
                <a
                  v-if="configurationData.showAccessMakeAppShortCut"
                  :class="getCss('userinfo-text-button')"
                  @click="showAccessMakeAppShortCutFunc"
                >添加快捷方式</a>
                <a :class="getCss('userinfo-text-button')"
                   v-if="!configurationData.disableChangeLogin"
                   @click="change">切换登录方式</a>
                <a :class="getCss('userinfo-text-button')"
                   v-if="showLogout"
                   @click="handleLogout">注销</a>
              </div>
            </div>
            <div :class="getCss('not-login')" v-else :style="styles.fontStyle">
              <span>
                <a @click="showLogin">HI~，请登录</a>
              </span>
            </div>
          </div>
    </template>
      <!-- 登录弹窗start -->
      <div :class="getCss('login-tc')" v-show="isShowLogin">
        <div :class="getCss('login-tc-zz')" ></div>

        <div :class="getCss('login-div')">
          <div :class="getCss('login-tc-text-body')">
            <p :class="getCss('login-title')">{{ loginTitle }}</p>
            <div :class="getCss('login-body')">
              <div :class="getCss('login-item-wx')">
                <div :class="getCss('login-wx')" @click="wxLogin"
                     :style="imposeLogin === 2 ? disableLogin : '' ">
                  <img src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/loginWx.png"
                       :class="getCss('login-img-wx')" alt=""/>
                </div>
                <div :class="getCss('login-wx-text')" :style="imposeLogin === 2 ? disableLogin : '' ">
                  <p :class="getCss('login-btn-text-p')">微信登录</p>
                </div>
                <p :class="getCss('login-now-text')" v-show="loginType === 'wx' && isLogin">（当前）</p>
              </div>
              <!--<div :class="getCss('login-body-kb')"></div>-->
              <div :class="getCss('login-item-qq')">
                <div :class="getCss('login-qq')" @click="qqLogin"
                     :style="imposeLogin === 1 ? disableLogin : '' ">
                  <img src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/loginQq.png"
                       :class="getCss('login-img-qq')" alt=""/>
                </div>
                <div :class="getCss('login-qq-text')" :style="imposeLogin === 1 ? disableLogin : '' ">
                  <p :class="getCss('login-btn-text-p')">QQ登录</p>
                </div>
                <p :class="getCss('login-now-text')" v-show="loginType === 'qc' && isLogin">（当前）</p>
              </div>
            </div>
          </div>
          <div :class="getCss('login-tc-close-div')">
            <span :class="getCss('login-tc-close')" @click="closeLogin">
              <img src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/close.png" alt="">
            </span>
          </div>
        </div>
      </div>
      <!-- 登录弹窗end -->
	  <!-- 授权弹窗start -->
      <van-popup v-model="showConfirmPop" round position="center" :style="showComfirmPopStyle">
        <div :class="getCss('add-area-pop-content')">
          <div :class="getCss('role-list-title')">
            请确认授权
          </div>
          <div :class="getCss('add-area-pop-body')">
            <div :class="getCss('confirm-content')">
              心悦俱乐部将获取你在《{{ authorizedGameName}}》的大区信息、角色昵称，以发放游戏权益内容。
            </div>
          </div>
          <div :class="getCss('bind-role-act')">
            <span :class="getCss('bind-role-top-line')"></span>
            <div :class="getCss('bind-role-act-cancel')" @click="cancelAuthorize">取消</div>
            <div :class="getCss('bind-role-act-confirm')" @click="confirmAuthorize">确定</div>
            <span :class="getCss('bind-role-center-line')"></span>
          </div>
        </div>
      </van-popup>
      <!-- 授权弹窗end -->
      <!-- 角色列表弹窗start -->
      <div :class="getCss('role-list-tc')" v-show="isShowRoleList">
        <div :class="getCss('login-tc-zz')" ></div>
        <div :class="getCss('role-list-content')">
          <div :class="getCss('role-list-title')">
            请选择游戏角色
          </div>
          <div :class="getCss('bind-role-body')">
            <div :class="getCss('bind-role-hide-scroll')">
              <ul :class="getCss('bind-role-content')">
                <li :class="getCss('bind-role-list')" v-if="isRoleReady === true">
                  <div :class="getCss('bind-role-info')">
                    <div :class="getCss('bind-role')">{{roleName}}</div>
                    <div :class="getCss('bind-area')">{{partitionName}}</div>
                  </div>
                  <div :class="getCss('is-bind-role')" @click="changeSelect(roleInfo,-1)">
                    <div :class="getCss('is-bind')" v-show="checkIndex === -1">
                      <img src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/ybd.png" alt="">
                    </div>
                    <div :class="getCss('no-bind')" v-show="checkIndex !== -1">
                      <img src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/nbd.png" alt="">
                    </div>
                  </div>
                  <span :class="getCss('bind-role-line')"></span>
                </li>
                <template v-if="getAllBindRoleTag && bindRoleList.length>0">
                  <li :class="getCss('bind-role-list')" v-for=" (bindinfo, index) in bindRoleList" :key="index"
                      v-show="bindinfo.role_id !== roleInfo.role_id || bindinfo.partition_id !== roleInfo.partition_id">
                    <div :class="getCss('bind-role-info')">
                      <div :class="getCss('bind-role')">{{bindinfo.role_name | base64decode}}</div>
                      <div :class="getCss('bind-area')">{{bindinfo.partition_name | base64decode}}</div>
                    </div>
                    <div :class="getCss('is-bind-role')" @click="changeSelect(bindinfo,index)">
                      <div :class="getCss('is-bind')" v-show="index === checkIndex">
                        <img src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/ybd.png" alt="">
                      </div>
                      <div :class="getCss('no-bind')" v-show="index !== checkIndex">
                        <img src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/nbd.png" alt="">
                      </div>
                    </div>
                    <span :class="getCss('bind-role-line')"></span>
                  </li>
                </template>
              </ul>
            </div>
          </div>
          <div :class="getCss('add-other-role')" @click="showAddRolePopup">
            <img :class="getCss('add-other-role-img')" src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/add_icon.png" alt="">
            <span :class="getCss('add-other-role-span')">选择其他角色</span>
          </div>
          <div :class="getCss('bind-role-act')">
            <span :class="getCss('bind-role-top-line')"></span>
            <div :class="getCss('bind-role-act-cancel')" @click="closeRoleList">取消</div>
            <div :class="getCss('bind-role-act-confirm')" @click="changeActBind">确定</div>
            <span :class="getCss('bind-role-center-line')"></span>
          </div>
        </div>
      </div>
      <!-- 角色列表弹窗end -->
      <!-- 添加游戏角色start -->
      <van-popup v-model="showAddRolePop" round position="center" :style="showAddRolePopStyle">
        <div :class="getCss('add-area-pop-content')">
          <div :class="getCss('role-list-title')">
            添加游戏角色
          </div>
          <div :class="getCss('add-area-pop-body')">
            <div class="s_content">
              <div :class="getCss('add-area-pop-list')" v-if="!isClientGame">
                <p :class="getCss('add-area-pop-p-left')">平台</p>
                <p :class="getCss('add-area-pop-p-right')" @click="showAreaPopup" :style="areaFontStyle">
                  <span :class="getCss('color-light')" v-if="selectedArea === -1 ">请选择</span>
                  <span :class="getCss('color-dark')" v-else>{{ selectedArea }}</span>
                  <img
                    :class="getCss('arrowhead-box')"
                    src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/arrowhead.png"
                    v-show="selectedArea === -1"
                    :style="arrowheadStyle"
                    alt=""
                  >
                </p>
                <span :class="getCss('add-area-pop-line')"></span>
              </div>
              <div :class="getCss('add-area-pop-list')">
                <p :class="getCss('add-area-pop-p-left')">区服</p>
                <p :class="getCss('add-area-pop-p-right')" @click="showPartitionPopup" :style="areaFontStyle">
                  <span :class="getCss('color-light')" v-if="selectedPartitionName === -1 ">请选择</span>
                  <span :class="getCss('color-dark')" v-else>{{ selectedPartitionName }}</span>
                  <!--{{ selectedPartitionName === -1 ? '请选择' : selectedPartitionName }}-->
                  <img
                    :class="getCss('arrowhead-box')"
                    src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/arrowhead.png"
                    v-show="selectedPartitionName === -1"
                    :style="arrowheadStyle"
                    alt=""
                  >
                </p>
                <span :class="getCss('add-area-pop-line')"></span>
              </div>
              <div :class="getCss('add-area-pop-list')">
                <p :class="getCss('add-area-pop-p-left')">角色</p>
                <p :class="getCss('add-area-pop-p-right')" @click="showRolePopup" :style="areaFontStyle">
                  <span :class="getCss('color-light')" v-if="selectedRoleName === -1 ">请选择</span>
                  <span :class="getCss('color-dark')" v-else>{{ selectedRoleName }}</span>
                  <img
                    :class="getCss('arrowhead-box')"
                    src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/arrowhead.png"
                    v-show="selectedRoleName === -1"
                    :style="arrowheadStyle"
                    alt=""
                  >
                </p>
              </div>
            </div>
          </div>
          <div :class="getCss('bind-role-act')">
            <span :class="getCss('bind-role-top-line')"></span>
            <div :class="getCss('bind-role-act-cancel')" @click="closeAddRolePop">取消</div>
            <div :class="getCss('bind-role-act-confirm')" @click="confirmAddRole">确定</div>
            <span :class="getCss('bind-role-center-line')"></span>
          </div>
        </div>
      </van-popup>
      <!-- 添加游戏角色end -->
      <div :class="getCss('show-area-pop')">
        <!-- 选择平台弹窗开始 -->
        <van-popup v-model="showAreaPop" round position="bottom" :style="borderRadiusStyle">
          <van-picker
            title="选择平台"
            show-toolbar
            :columns="areaColumn"
            value-key="text"
            visible-item-count="3"
            confirm-button-text="确定"
            @confirm="areaOnConfirm"
            @cancel="areaOnCancel"
            @change="areaOnChange"
          />
        </van-popup>
        <!-- 选择平台弹窗结束 -->
        <!-- 选择区服弹窗开始 -->
        <div :class="getCss('showPartition')">
          <van-popup v-model="showPartitionPop" round position="bottom" :style="borderRadiusStyle" @closed="clearInfo">
            <van-field
              placeholder="搜索"
              v-model="keyWord"
              left-icon="https://game.gtimg.cn/images/tgclub/act/vipmb_new/search.png"
              @input="handleSearchPartitions(keyWord)"
              v-show="areaNeedSearch"
            >
              <template #button>
                <van-button size="small" type="primary" @click="clearAllInput"></van-button>
              </template>
            </van-field>
            <van-picker
              :class="areaNeedSearch === true?getCss('needSearch'):getCss('notNeedSearch')"
              title="选择区服"
              show-toolbar
              :columns="searchPartitionColumns"
              value-key="name"
              :default-index="0"
              visible-item-count="7"
              confirm-button-text="确定"
              @confirm="partitionOnConfirm"
              @cancel="partitionOnCancel"
              @change="partitionOnChange"
            >
              <template #option="option">
                <div style="display: flex; flex-direction: column; align-items: center;">
                <div>{{ option.name | base64decode }}</div>
                </div>
              </template>
            </van-picker>
            <div
              :class="getCss('areaNoData')"
              :style="{height: scrollerHeight,width:'100%' }"
              v-show="keyWord !== '' && searchPartitionColumns.length === 0"
            >
            </div>
          </van-popup>
        </div>
        <!-- 选择区服弹窗结束 -->
        <!-- 选择角色弹窗开始 -->
        <van-popup v-model="showRolePop" round position="bottom" :style="borderRadiusStyle">
          <van-picker
            title="选择角色"
            show-toolbar
            :columns="roleList"
            value-key="role_name"
            visible-item-count="3"
            confirm-button-text="确定"
            @confirm="roleOnConfirm"
            @cancel="roleOnCancel"
            @change="roleOnChange"
          >
            <template #option="option">
              <div style="display: flex; flex-direction: column; align-items: center;">
                <div>{{ option.role_name | base64decode }}</div>
              </div>
            </template>
          </van-picker>
        </van-popup>
        <!-- 选择角色弹窗结束 -->
      </div>
    </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { baseComponents, common, componentBaseMixin } from '@tencent/ceiba-base-components';
import 'vant/lib/area/style';
import 'vant/lib/index.css';
import { Partition, Role } from '@tencent/ceiba-base-components/src/components/apis';

export default {
  name: 'CTgclubUserAreaFlatten',
  components: {
    VanPopup: () => import('vant/lib/popup'),
    VanPicker: () => import('vant/lib/picker'),
    VanField: () => import('vant/lib/field'),
    VanButton: () => import('vant/lib/button'),
  },
  filters: {
    base64decode(value) {
      return common.tool.Base64.decode(value);
    },
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'tgclub-user-area-flatten-',
      isShowLogin: false,
      scrollYTop: 0,
      loginTitle: '请登录账号',
      loginType: '',
      isShowInfo: false,
      imposeLogin: 0, // 限制参与 0不限，1仅限微信，2仅限QQ
      gameCode: '',
      authorizedGameName: '',
      isShowRoleList: false,
      areaColumns: [{ text: 'iOS 手Q', device: 'ios', area: 'qq' }, { text: '安卓 手Q', device: 'android', area: 'qq' }, { text: 'iOS 微信', device: 'ios', area: 'wx' }, { text: '安卓 微信', device: 'android', area: 'wx' }],
      showConfirmPop: false,
      showAreaPop: false,
      showPartitionPop: false,
      showRolePop: false,
      showAddRolePop: false,
      selectedBindRoleInfo: {},

      selectedDevice: 'ios',
      selectedArea: -1,
      selectedRoleId: -1,
      selectedRoleName: -1,
      selectedPartitionId: -1,
      selectedPartitionName: -1,
      selectedRoleInfo: {},
      partitionColumns: [{ id: '', name: '' }],
      roleList: [],
      getAllBindRoleTag: false,

      checkIndex: -1,
      keyWord: '',
      searchPartitionColumns: [{ id: '', name: '' }],
      tempHeight: 0,
      firstLock: false,
    };
  },
  computed: {
    // 端游判断
    isClientGame() {
      return this.$actInfo && this.$actInfo.game_type === 1;
    },
    wrapStyle() {
      return {
        ...this.styles.base,
        zIndex: '100',
      };
    },
    loginLineStyle() {
      const width1 = this?.styles?.loginLineStyle?.width || '5.98rem';
      const color = this?.styles?.loginLineStyle?.backgroundColor || '#FFFFFF';
      return {
        // ...loginLine,
        width: width1,
        border: `0.01rem solid ${color}`,
      };
    },
    arrowheadStyle() {
      const arrowheadWidth = this?.styles?.areaBoxStyle?.fontSize || '0.28rem';
      let topNum = arrowheadWidth.replace('rem', '');
      topNum = parseFloat(topNum) / 2;
      return {
        width: arrowheadWidth,
        marginTop: `-${topNum}rem`,
      };
    },
    areaFontStyle() {
      const areaFontSize = this?.styles?.areaBoxStyle?.fontSize || '0.28rem';
      const areaFontColor = this?.styles?.areaBoxStyle?.color || '#BDBDC8';
      return {
        fontSize: areaFontSize,
        color: areaFontColor,
      };
    },
    bindBtnText() {
      return this.configurationData.bind_btn_text || '绑定QQ';
    },
    isWX() {
      //  ios safari | 心悦app | wx客户端
      const isWxCookie = common.tool.getCookie('acctype') === 'wx';
      console.log('isWxCookie = ', isWxCookie);
      return isWxCookie ? isWxCookie : this.$platform.isWX;
    },
    isSafari() {
      return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    },
    showLogout() {
      return this.$actInfo && !this.$ast.isAPP();
    },
    disableLogin() {
      return {
        opacity: .2,
        cursor: 'no-drop',
      };
    },
    loginInfoStyle() {
      const loginInfoBackgroundColor = this?.styles?.loginBgStyle?.color || '#fff';
      // let topNum = this.styles.base.top.replace('rem', '');
      // topNum = parseFloat(topNum) + 1;
      return {
        backgroundColor: loginInfoBackgroundColor,
        // top: `${topNum}rem`,
      };
    },
    loginJtStyle() {
      const loginInfoBackgroundColor = this?.styles?.loginBgStyle?.color || '#fff';
      return {
        backgroundColor: loginInfoBackgroundColor,
      };
    },
    loginInfoFontStyle() {
      const fontStyle = this?.styles?.fontStyle || {};
      return {
        ...fontStyle,
      };
    },
    loginInfoLineStyle() {
      // const lineStyle = this?.styles?.fontStyle?.color || '#000';
      const lineStyle = '#000000';
      return {
        borderBottom: `.01rem solid ${lineStyle}`,
      };
    },
    fixTop() {
      const topNum = this.styles.base.top;
      return {
        top: topNum,
      };
    },
    showRole() {
      const buShanDang = this.actInfo.extendConfig?.bushandang || false;
      if (buShanDang) {
        return this.isRoleStatusValid;
      }
      return this?.actInfo?.extendConfig?.forceRole;
    },
    areaNeedSearch() {
      return this.configurationData.areaNeedSearch || false;
    },
    userBindText() {
      return this.isRoleReady ? '更改绑定' : '绑定角色';
    },
    userName() {
      return this.isLogin ? this.userInfo.nickName : '';
    },
    userAvatar() {
      return this.isLogin ? this.userInfo.avatar : '';
    },
    partitionName() {
      return this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.partition_name || '') : '';
    },
    roleName() {
      if (this.isRoleReady) {
        return common.tool.Base64.decode(this.roleInfo.role_name || '');
      }
      return '';
    },
    showAddRolePopStyle() {
      return {
        width: '6rem',
        height: '6.24rem',
        background: '#FFF',
        overflowY: 'hidden',
        borderRadius: '0.24rem',
      };
    },
    borderRadiusStyle() {
      return {
        borderRadius: '0.24rem 0.24rem 0 0',
      };
    },
    showComfirmPopStyle() {
      return {
        width: '6rem',
        height: '3.82rem',
        background: '#FFF',
        overflowY: 'hidden',
        borderRadius: '0.24rem',
      };
    },
    areaColumn() {
      if (this.loginType === 'wx') {
        return [{ text: 'iOS 微信', device: 'ios', area: 'wx' }, { text: '安卓 微信', device: 'android', area: 'wx' }];
      }
      return [{ text: 'iOS 手Q', device: 'ios', area: 'qq' }, { text: '安卓 手Q', device: 'android', area: 'qq' }];
    },
    scrollerHeight() {
      console.log('tempHeight111', this.tempHeight);
      return this.tempHeight;
    },
  },
  async mounted() {
    console.log('configurationData=', this.configurationData);
    console.log('isRoleReady==', this.isRoleReady);
    document.addEventListener('click', (e) => {
      if (this.$el && !this.$el.contains(e.target)) {
        this.isShowInfo = false; // 点击其他区域关闭
      }
    });
    await this.initialize();
    if (this.$isInEditor && !this.isInPreview) return;
    if (!this.isLogin && !this.$ast.isAPP()) {
      this.reportExposeFunc('login_expose', { type: 'flatten_nologin' });
    }
  },
  methods: {
    async initialize() {
      console.log('extend_config', this?.actInfo?.extendConfig?.forceRole);
      if (this.$isInEditor && !this.isInPreview) return;
      // 用户登陆
      this.checkShowLogin();
      this.$eventBus.$onLogined(this.imposeLoginTips);
      this.gameCode = this.configurationData.game_code ? this.configurationData.game_code : this.actInfo.game_code;
      this.authorizedGameName = this.configurationData.authorizedGameName ? this.configurationData.authorizedGameName : '';
    },
    showLogin() {
      if (this.$isInEditor && !this.isInPreview) return;
      this.loginTitle = '请登录账号';
      this.isShowLogin = true;
      this.fixedBody();
      this.reportExposeFunc('show_pop', { pop_name: 'login_pop' });
      if (!this.$ast.isAPP()) {
        this.reportFunc('login_click', { type: 'flatten_nologin' });
      }
    },
    closeLogin() {
      this.isShowLogin = false;
      this.removeFixedBody();
      this.reportFunc('click_pop', { pop_name: 'login_pop', type: 'close' });
    },
    fixedBody() {
      const bodyEl = document.body;
      let top = 0;
      top = window.scrollY;
      this.scrollYTop = top;
      bodyEl.style.position = 'fixed';
      bodyEl.style.top = `${-top}px`;
    },
    removeFixedBody() {
      const bodyEl = document.body;
      bodyEl.style.position = '';
      bodyEl.style.top = '';
      window.scrollTo(0, this.scrollYTop); // 回到原先的top
    },
    showInfoTc() {
      this.isShowLogin = false;
      this.isShowInfo = !this.isShowInfo;
      this.reportFunc('login_click', { type: 'flatten_login' });
      this.reportExposeFunc('login_expose', { type: 'flatten_change' });
      this.reportExposeFunc('login_expose', { type: 'flatten_role' });
      this.reportExposeFunc('login_expose', { type: 'flatten_gift' });
    },
    change() {
      if (this.$ast.isAPP()) {
        window.Tgclub?.showLoginWithScheme(window.location.href);
      } else {
        this.loginTitle = '切换登录方式';
        this.isShowInfo = false;
        this.isShowLogin = true;
        this.fixedBody();
      }
      this.reportFunc('login_click', { type: 'flatten_change' });
    },
    wxLogin() {
      if (this.imposeLogin === 2) {
        return;
      }
      this.login({
        loginType: 'wx',
      });
      this.handleClickEvent();
      console.log('wxLogin');
      this.reportFunc('click_pop', { pop_name: 'login_pop', type: 'wx' });
    },
    qqLogin() {
      if (this.imposeLogin === 1) {
        return;
      }
      this.login({
        loginType: 'qq',
      });
      this.handleClickEvent();
      console.log('qqLogin');
      this.reportFunc('click_pop', { pop_name: 'login_pop', type: 'qq' });
    },
    async handleLogout() {
      this.logout();
    },
    checkShowLogin() {
      if (this.$platform.isWX || this.$platform.isSafari) {
        this.imposeLogin = this.configurationData.imposeLogin;
      } else {
        this.imposeLogin = 2;
      }
      console.log('imposeLogin', this.isSafari);
      if (this.isClientGame) {
        this.imposeLogin = 2;
      }
    },
    imposeLoginTips() {
      if (this.isLogin) {
        this.loginType = this.userInfo.acctype;
      }
      if ((this.configurationData.imposeLogin === 2 && this.loginType === 'wx')
        || (this.configurationData.imposeLogin === 1 && this.loginType === 'qc')) {
        if (this.loginType === 'wx') {
          this.confirmMsg('当前活动仅限QQ用户参与', '切换为QQ登录');
        } else {
          this.confirmMsg('当前活动仅限微信用户参与', '切换为微信登录');
        }
        this.reportExposeFunc('show_pop', { pop_name: 'login_impose' });
      } else {
        this.handleLogin();
      }
    },
    confirmMsg(tipMsg, confirmMsg) {
      const that = this;
      this.$confirm({
        msg: tipMsg,
        confirmText: confirmMsg,
        cancel() {
          that.reportFunc('click_pop', { pop_name: 'login_impose', type: 'cancel' });
        },
        confirm() {
          if (that.$ast.isAPP()) {
            window.Tgclub.showLoginWithScheme(window.location.href);
            return;
          }
          that.change();
          that.reportFunc('click_pop', { pop_name: 'login_impose', type: 'switch' });
        },
      });
    },
    async handleLogin() {
      // this.checkShowLogin();
      // 自动绑定角色
      const buShanDang = this.actInfo.extendConfig?.bushandang || false;
      if (buShanDang) {
        if (this.isRoleStatusValid) {
          await this.checkRoleInfo();
          await this.getAllBindRole();
        }
      } else {
        if (this?.actInfo?.extendConfig?.forceRole) {
          await this.checkRoleInfo();
          await this.getAllBindRole();
        }
      }
      this.reportExposeFunc('login_expose', { type: 'flatten_login' });
    },
    doBindRole() {
      this.isShowInfo = false;
      this.reportFunc('login_click', { type: 'flatten_role' });
      if (this.bindRoleList.length > 0) {
        this.showRoleList();
        return;
      }
      this.showConfirmPop = true;
      this.reportExposeFunc('show_pop', { pop_name: 'authorized' });
    },
    cancelAuthorize() {
      this.showConfirmPop = false;
      this.reportFunc('click_pop', { pop_name: 'authorized', type: 'cancel' });
    },
    confirmAuthorize() {
      this.showConfirmPop = false;
      this.showAddRolePopup();
      this.reportFunc('click_pop', { pop_name: 'authorized', type: 'confirm' });
    },
    showAddRolePopup() {
      this.showAddRolePop = true;
      this.isShowRoleList = false;
      this.reportExposeFunc('show_pop', { pop_name: 'add_role' });
      this.reportFunc('click_pop', { pop_name: 'select_role', type: 'other' });
      this.reportExposeFunc('login_expose', { type: 'add_role' });
      if (this.isClientGame) {
        this.selectedDevice = common.platform.isIos ? 'ios' : 'android';
        if (common.tool.getCookie('acctype') === 'wx') {
          this.fetchPartition('wx');
        } else {
          this.fetchPartition('qq');
        }
      }
    },
    closeAddRolePop() {
      this.selectedArea = -1;
      this.selectedPartitionName = -1;
      this.selectedPartitionId = -1;
      this.selectedRoleName = -1;
      this.selectedRoleId = -1;
      this.roleList = [];
      this.partitionColumns = [];
      this.showAddRolePop = false;
    },
    /**
     * 确认添加角色到角色选择列表
     * @returns {Promise<void>}
     */
    async confirmAddRole() {
      if (Object.keys(this.selectedRoleInfo).length === 0) {
        this.$toast('请选择角色');
        return;
      }

      const roleInfo = this.selectedRoleInfo;
      const scene = this.configurationData?.scene ? `${this.configurationData.scene}` : 'xinyue';
      await this.bindRoleByScene({
        roleInfo,
        scene,
      });

      this.showAddRolePop = false;
      await this.getBindRoleListByScene(scene);
      this.getAllBindRoleTag = true;
      this.reportFunc('click_pop', { pop_name: 'add_role', type: 'confirm', status: '1' });
      this.closeAddRolePop();
      this.isShowRoleList = true;
    },
    showRoleList() {
      this.isShowInfo = false;
      this.isShowRoleList = true;
      this.reportExposeFunc('show_pop', { pop_name: 'select_role' });
      this.reportFunc('login_click', { type: 'flatten_role' });
    },
    closeRoleList() {
      this.isShowRoleList = false;
      this.reportFunc('click_pop', { pop_name: 'select_role', type: 'cancel' });
    },
    // 上报回流
    reportReturnGameFlow(roleInfo) {
      const { reportReturnGameFlowId = 0 } = this.configurationData;
      if (reportReturnGameFlowId > 0 && roleInfo) {
        console.log('access report after report  role=', roleInfo, reportReturnGameFlowId);
        this.flowRequest({
          flowId: reportReturnGameFlowId,
          params: {
            role: roleInfo,
          },
        }).then(res => console.log('用户回流上报流程reportReturnGameFlowId =', reportReturnGameFlowId, '请求返回 = ', res));
      }
    },
    showBindPhoneFunc() {
      this.isShowInfo = false;
      this.$eventBus.$emit('ceiba:custom:events:call:use:bind:phone:pop', {});
      console.log('ceiba:custom:events:call:use:bind:phone:pop event');
    },
    showBindQQFunc() {
      this.isShowInfo = false;
      this.$eventBus.$emit('ceiba:common:event:account-wx-qq-fill', {});
      console.log('ceiba:common:event:account-wx-qq-fill event');
    },
    // 快捷方式
    showAccessMakeAppShortCutFunc() {
      this.$eventBus.$emit('ceiba:custom:events:call:use:add:shortcut', {});
    },
    async handleClaimRecord() {
      this.reportFunc('login_click', { type: 'flatten_gift' });
      this.isShowInfo = false;
      const pageSize = this.configurationData.popupPageSize || 6; // 每页记录数可配置,默认6
      await baseComponents.pacakgeClaimRecords.showPackageClaimRecords(this.gameCode, {
        hidePackageIds: (this.configurationData.hidePackageIds || '').split(','),
        params: {
          activity_id: this.actInfo.activity_id.toString(),
          business_id: this.actInfo.ast,
          resource_id: this.configurationData?.resource_id ? `${this.configurationData.resource_id}` : '',
          flow_version: this.actInfo.flow ? parseInt(this.actInfo.flow, 10) : 1,
          moduleId: this.configurationData?.moduleId ? `${this.configurationData.moduleId}` : '',
          category: this.configurationData?.category ? `${this.configurationData.category}` : '',
          iExcludePackageId: this.configurationData?.iExcludePackageId ? `${this.configurationData.iExcludePackageId}` : '',
          scene: this.configurationData?.scene ? `${this.configurationData.scene}` : 'ceiba_act',
        },
        pageSize,
        option: {
          header: false,
          footer: false,
          height: '3.6rem',
          width: '7.2rem',
          closeLocation: 'top-right',
          close: true,
          dialogStyle: Object.assign(
            {},
            {
              color: this.configurationData.recordsFontColor || '#000000',
              backgroundImage: `url(${this.configurationData.packageClaimBackgroundImage})`,
            },
          ),
        },
      });
    },
    async handleRechargeRecord() {
      this.isShowInfo = false;
      if (!this.roleInfo.role_id && this.showRole) {
        this.$alert({ msg: '请先绑定角色' });
        return false;
      }
      const myRoleInfo = this.roleInfo;
      await baseComponents.rechargeRecord.showRechargeRecord({
        thisFlowRequest: this.flowRequest,
        myRoleInfo,
        payBusiness: this.configurationData.payBusiness,
        sellChannel: this.configurationData.sellChannel,
        flowId: this.configurationData.rechargeRecordFlowId,
        spInfo: '',
        pageSize: 6,
        option: {
          header: false,
          footer: false,
          height: '3.6rem',
          width: '7.2rem',
          closeLocation: 'top-right',
          close: true,
          dialogStyle: Object.assign(
            {},
            {
              color: this.configurationData.rechargeRecordFontColor || '#c20303',
              backgroundImage: `url(${this.configurationData.rechargeRecordBackgroundImage})`,
            },
          ),
        },
      });
    },
    showAreaPopup() {
      this.isShowRoleList = false;
      this.showAreaPop = true;
      this.reportFunc('click_pop', { pop_name: 'add_role', type: 'plat' });
    },
    areaOnConfirm(value) {
      console.log(`当前值：${value.text}, 当前索引：${value.area}, 当前索引：${value.device}`);
      console.log(this.partitionList);
      this.selectedArea = value.text;
      this.selectedDevice = value.device;
      this.fetchPartition(value.area);
      this.showAreaPop = false;
    },
    areaOnChange(picker, value) {
      console.log(`当前值：${value.text}, 当前索引：${value.area}, 当前索引：${value.device}`);
    },
    areaOnCancel() {
      this.selectedArea = -1;
      this.showAreaPop = false;
    },
    showPartitionPopup() {
      if (!this.isClientGame && this.selectedArea === -1) {
        this.$toast('请选择平台');
        return false;
      }
      this.isShowRoleList = false;
      this.keyWord = '';
      this.showPartitionPop = true;
      if (this.partitionColumns.length > 0) {
        this.selectedRoleName = -1;
        this.roleList = [];
        this.refreshRoleList(this.partitionColumns[0].name);
      }
      this.searchPartitionColumns = this.partitionColumns;
      this.$nextTick(() => {
        const els = this.getCss('showPartition');
        const el = document.querySelector(`.${els}` + ' .van-picker__columns');
        if (el !== undefined && this.firstLock === false) {
          const h1 = `${el.offsetHeight}px`;
          console.log('scrollerHeight', h1);
          this.tempHeight = h1;
          this.firstLock = true;
          console.log('tempHeight', this.tempHeight);
        }
      });
    },
    async partitionOnConfirm(value) {
      this.selectedPartitionName = common.tool.Base64.decode(value.name);
      this.selectedPartitionId = value.id;
      try {
        await this.refreshRoleList(value.name);
        console.log('partitionOnConfirm===', this.roleList);
        if (this.roleList.length === 0) {
          this.$toast('你在该区服没有角色');
          return false;
        }
        if (this.roleList.length === 1) {
          this.selectedRoleName = common.tool.Base64.decode(this.roleList[0].role_name);
          this.selectedRoleId = this.roleList[0].role_id;
          [this.selectedRoleInfo] = this.roleList;
        }
        this.showPartitionPop = false;
      } catch (err) {
        console.error('refreshRoleList fail, err=', err);
        if (err?.data?.ret === 300011) {
          this.$toast('你在该区服没有角色');
        } else {
          const txt = err?.data?.msg || '角色查询失败';
          this.$toast(txt);
        }
      }
    },
    partitionOnChange(picker, value) {
      console.log(`当前值：${value.name}, 当前索引：${value.id}`);
      this.selectedRoleName = -1;
      this.roleList = [];
      // this.refreshRoleList(value.name);
    },
    partitionOnCancel() {
      this.selectedPartitionName = -1;
      this.selectedPartitionId = -1;
      this.showPartitionPop = false;
    },
    showRolePopup() {
      if (!this.isClientGame && this.selectedArea === -1) {
        this.$toast('请选择平台');
        return false;
      }
      if (this.selectedPartitionId === -1) {
        this.$toast('请选择区服');
        return false;
      }
      if (this.roleList.length === 0) {
        this.$toast('你在该区服没有角色');
        return false;
      }
      this.isShowRoleList = false;
      this.showRolePop = true;
    },
    roleOnConfirm(value, index) {
      if (typeof (value) === undefined || typeof (value) === 'undefined') {
        this.$toast('你在该区服没有角色');
        return;
      }
      console.log(`当前值：${value.role_name}, 当前索引：${value.role_id}, 当前索引：${index}`);
      this.selectedRoleName = common.tool.Base64.decode(value.role_name);
      this.selectedRoleId = value.role_id;
      this.selectedRoleInfo = value;
      this.showRolePop = false;
    },
    roleOnChange(picker, value, index) {
      console.log(`当前值：${value.role_name}, 当前角色id：${value.role_id}, 当前索引：${index}`);
    },
    roleOnCancel() {
      this.showRolePop = false;
    },
    async fetchPartition(area) {
      console.log('fetchPartition area====', area);
      this.selectedPartitionId = -1;
      this.selectedPartitionName = -1;
      this.selectedRoleName = -1;
      this.roleList = [];
      this.partitionColumns = await Partition.fetch({
        game_code: this.gameCode,
        device: this.selectedDevice,
        area,
      });
    },
    async refreshRoleList(partitionName) {
      this.roleList = [];
      const partitionInfo = this.partitionColumns.find(item => item.name === partitionName);
      const { id: partitionId  = '' }  =   partitionInfo || {};
      this.selectedRoleId = '';
      this.roleList = await Role.fetch({
        game_code: this.gameCode,
        partition_id: +partitionId,
        device: this.selectedDevice,
      });
    },
    async getAllBindRole() {
      if (this.$isInEditor && !this.isInPreview) return;
      await this.getBindRoleListByScene(this.configurationData.scene ? `${this.configurationData.scene}` : 'xinyue');
      this.getAllBindRoleTag = true;
      console.log('getAllBindRole===', this.bindRoleList);
      console.log('getAllBindRoleTag===', this.getAllBindRoleTag);
    },
    changeSelect(role, index) {
      this.checkIndex = index;
      this.selectedBindRoleInfo = role;
    },
    /**
     * 修改当前活动绑定角色数据
     * @returns {Promise<void>}
     */
    async changeActBind() {
      console.log('changeActBind===', this.selectedBindRoleInfo);

      if (Object.keys(this.selectedBindRoleInfo).length === 0) {
        this.$toast('您尚未勾选角色');
        return;
      }
      let oldInfo = '';
      if (this.isReady) {
        oldInfo = this.roleInfo?.role_name ? this.roleInfo?.role_name : '';
      }
      this.$emit(
        'finish',
        this.roleList.find(role => role.role_id === this.selectedBindRoleInfo.role_id),
      );
      const roleInfo = this.selectedBindRoleInfo;
      try {
        await this.saveCurrentRole({
          isRoleReady: true,
          roleInfo,
        });
        console.log('changeActBind', this.roleInfo);
        const newInfo = this.roleInfo?.role_name;

        if (oldInfo !== newInfo) {
          this.isShowRoleList = false;
          this.$toast('绑定成功');
        }
        this.checkIndex = -1;
        this.reportReturnGameFlow(roleInfo);
      } catch (e) {
        this.$toast('绑定失败，请稍候再试');
        console.error('action bind role fail  response =', e);
      }
      this.reportFunc('click_pop', { pop_name: 'select_role', type: 'confirm' });
    },
    reportFunc(key, obj) {
      if (this.$isInEditor && !this.isInPreview) return;
      if (typeof  this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventData: obj,
        };
        this.reportClickRaw(params);
        console.log('reportFunc sign_up data =', params);
      }
    },
    reportExposeFunc(key, obj) {
      if (this.$isInEditor && !this.isInPreview) return;
      if (typeof  this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventType: 1001,
          eventKey: key,
          eventData: obj,
        };
        this.reportClickRaw(params);
        console.log('reportExposeFunc sign_up data =', params);
      }
    },
    /**
     * 处理区服搜索功能
     * @param keyWord 搜索内容
     */
    handleSearchPartitions(keyWord) {
      const els = this.getCss('showPartition');
      const el = document.querySelector(`.${els}` + ' .van-picker__columns');
      if (keyWord === '') {
        this.searchPartitionColumns = this.partitionColumns;
        if (el !== undefined) {
          el.style.display = 'flex';
        }
        return;
      }
      const t = [];
      this.partitionColumns.forEach((item) => {
        const temp = common.tool.Base64.decode(item.name || '');
        if (temp.indexOf(keyWord) > -1) {
          t.push(item);
        }
      });
      this.searchPartitionColumns = t;
      if (this.searchPartitionColumns.length === 0) {
        if (el !== undefined) {
          el.style.display = 'none';
        }
      } else {
        if (el !== undefined) {
          el.style.display = 'flex';
        }
      }
    },
    clearAllInput() {
      this.keyWord = '';
      this.handleSearchPartitions(this.keyWord);
    },
    clearInfo() {
      this.keyWord = '';
      this.handleSearchPartitions(this.keyWord);
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
